import { VFlow } from 'bold-ui'
import { LoadingIndicator } from 'components/loading'
import { useCidadaoFciVisualizacaoQuery } from 'graphql/hooks.generated'
import { Endereco } from 'graphql/types.generated'
import React from 'react'

import { CidadaoFciCompartilhaProntuarioSection } from './components/CidadaoFciCompartilhaProntuario'
import { CidadaoFciCondicoesSaudeAutorreferidasSection } from './components/CidadaoFciCondicoesSaudeAutorreferidasSection'
import { CidadaoFciContatosSection } from './components/CidadaoFciContatosSection'
import { CidadaoFciDadosPessoaisSection } from './components/CidadaoFciDadosPessoaisSection'
import { CidadaoFciEnderecoSection } from './components/CidadaoFciEnderecoSection'
import { CidadaoFciInformacoesSociodemograficasSection } from './components/CidadaoFciInformacoesSociodemograficasSection'
import { CidadaoFciInformacoesSocioeconomicasSection } from './components/CidadaoFciInformacoesSocioeconomicas'
import { CidadaoFciSituacaoDeRuaSection } from './components/CidadaoFciSituacaoDeRuaSection'

interface CidadaoFciInformacoesViewProps {
  cidadaoId: ID
}

export function CidadaoFciInformacoesView(props: CidadaoFciInformacoesViewProps) {
  const { cidadaoId } = props

  const {
    data: { cidadao },
    loading,
  } = useCidadaoFciVisualizacaoQuery({
    variables: {
      id: cidadaoId,
    },
    fetchPolicy: 'network-only',
  })

  if (loading) return <LoadingIndicator />

  return (
    <VFlow vSpacing={2}>
      <CidadaoFciDadosPessoaisSection cidadao={cidadao} />
      <CidadaoFciContatosSection
        telefoneResidencial={cidadao.telefoneResidencial}
        telefoneCelular={cidadao.telefoneCelular}
        telefoneContato={cidadao.telefoneContato}
        email={cidadao.email}
      />
      <CidadaoFciInformacoesSociodemograficasSection
        informacoesSociodemograficas={cidadao.informacoesSociodemograficas}
        escolaridade={cidadao.escolaridade}
        cbo={cidadao.cbo}
      />
      <CidadaoFciInformacoesSocioeconomicasSection informacoesSocioeconomicas={cidadao.informacoesSocioEconomicas} />
      <CidadaoFciCondicoesSaudeAutorreferidasSection
        condicoesSaudeAutorreferidas={cidadao.condicoesSaudeAutorreferidas}
      />
      <CidadaoFciEnderecoSection
        statusSituacaoDeRua={cidadao.situacaoDeRua?.stSituacaoDeRua}
        paisResidencia={cidadao.paisExterior?.nome}
        endereco={cidadao.endereco as Endereco}
        localidadeExterior={cidadao.localidadeExterior}
      />
      {cidadao.situacaoDeRua && <CidadaoFciSituacaoDeRuaSection situacaoDeRua={cidadao.situacaoDeRua} />}
      <CidadaoFciCompartilhaProntuarioSection statusCompartilhaProntuario={cidadao.stCompartilhaProntuario} />
    </VFlow>
  )
}
